import fetch from 'isomorphic-fetch'
import { RSAA } from 'redux-api-middleware'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import * as types from './types'

const baseUrl = getEnv(Env.UserServiceUrl)

export const updateLifestyle = (payload: { currentPage: number; data: any }) => ({
  type: types.UPDATE_LIFESTYLE,
  payload,
})

export const updateAnonLifestyle = (payload: { currentPage: number; data: any }) => ({
  type: types.UPDATE_ANON_LIFESTYLE,
  payload,
  meta: { currentPage: payload.currentPage },
})

export const updateLoggedInLifestyle = (payload: { currentPage: number; data: any }) => ({
  [RSAA]: {
    endpoint: `${baseUrl}/userprofiles/lifestyle`,
    method: 'PUT',
    fetch,
    body: JSON.stringify(payload.data),
    headers: (state: any) => ({
      Authorization: `Bearer ${state.oidc.user.access_token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    }),
    types: [
      types.LIFESTYLE_UPDATE_REQUEST,
      {
        type: types.LIFESTYLE_UPDATE_SUCCESS,
        meta: { currentPage: payload.currentPage },
        payload: () => payload.data,
      },
      types.LIFESTYLE_UPDATE_FAILURE,
    ],
  },
})

export const getLifestyle = () => ({
  [RSAA]: {
    endpoint: `${baseUrl}/userprofiles/lifestyle`,
    method: 'GET',
    fetch,
    headers: (state: any) => ({
      Authorization: `Bearer ${state.oidc.user.access_token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    }),
    types: [types.GET_LIFESTYLE_REQUEST, types.GET_LIFESTYLE_SUCCESS, types.GET_LIFESTYLE_FAILURE],
  },
})
